export default __webpack_public_path__ + "static/media/MintLogo.7fcc03fd.webp";